const API_BASE = (import.meta as any).env.VITE_API_BASE || "";

export function getApiBase(): string {
  return String(API_BASE || "").replace(/\/$/, "");
}

export function getToken(): string {
  return localStorage.getItem("token") || "";
}

export function setToken(t: string) {
  localStorage.setItem("token", t);
}

export function clearToken() {
  localStorage.removeItem("token");
}

export async function api(path: string, init?: RequestInit) {
  const url = getApiBase() + path;
  const headers: Record<string, string> = {
    "content-type": "application/json",
    ...(init?.headers as any)
  };
  const token = getToken();
  if (token) headers["authorization"] = `Bearer ${token}`;

  const res = await fetch(url, { ...init, headers });
  const text = await res.text();
  let json: any = null;
  try { json = text ? JSON.parse(text) : null; } catch { json = { raw: text }; }
  return { res, json };
}
